// export const SCREEN = {
//     'Login': 'LOGIN',
//     'Search Results': 'SEARCH',
//     'Home': 'HOME',
//     //NAV_MENU: { KEY: 'menu', MIXPANEL: 'Nav Menu'},
//     'LIVE_TV': 'LIVE_TV',
//     //REWIND_LISTING: { KEY: 'home', MIXPANEL: 'REWIND_LISTING' },
//     //VOD_LISTING: { KEY: 'home', MIXPANEL: 'VOD_LISTING' },
//     //VOD_DETAILS: { KEY: 'home', MIXPANEL: 'VOD_DETAILS' },
//     //VOD_PLAYER: { KEY: 'home', MIXPANEL: 'VOD_PLAYER' },
//     'Watchlist': 'WATCHLIST'
// };

export const KEYS = {
    GENERAL: {
        WATCHLIST_TYPE: 'Watchlist Type',
        PROGRAM_TYPE: 'Program Type',
        SCREEN_NAME: 'Screen Name',
        ITEM_TYPE: 'Item Type',
        CAROUSLE_NAME: 'Carousel Name',
        LIST_INDEX: 'List Index',
        ERROR_CODE: 'Error Code',
        FILTER_TITLE: 'Filter Title',
        RESULTS_COUNT: 'Results Count',
        KEYWORD: 'Keyword',
        SEASON_NUMBER: 'Season Number',
        SERIES_NAME: 'Series Name',
        VOD_PROVIDER: 'VOD Provider',
        VOD_CATEGORY: 'VOD Category',
        FILTER_NAME: 'Filter Name',
        SORTING_TYPE: 'Sorting Type',
        PROVIDER_NAME: 'Provider Name',
        SEARCH_RECOMMENDATION_TYPE: 'Recommendation Type',
        BIOGRAPHY: 'Actor Name',
        DEVICE_NAME: 'Device Name',
        DEVICE_FAILURE: 'Failure Reason',
        DEVICE_COUNT: 'Device Count',
        ADD_DEVICE_SUCCESS: 'Add Device - Add Success',
        ADD_DEVICE_FAILED: 'Add Device- Add Failed',
        RATING_TYPE: 'Rating Type',
    },
    PEOPLE: {
        EMAIL: '$email',
        PHONE: '$phone',
        NAME: '$name',
        WEB_LANGUAGE: 'Web Language',
        LAST_LOGIN: 'Last Login',
        LAST_SIGN_OUT: 'Last Sign out',
        FIRST_APP_LOGIN: 'First App Login',
        LAST_HOME_VIEW: 'Last Home View',
        LAST_WATCH: 'Last Watch',
        SEARCH_KEYWORDS: 'Search Keywords',
        LAST_SEARCH: 'Last Search',
        SUBSCRIPTION_TYPE: 'Subscription Type',
        SUBSCRIPTION_DATE: 'Subscription Date',
        SUBSCRIPTION_PRICE: 'Subscription Price',
        EMAIL_VERIFIED: 'Email Verified',
        USER_PROFILES: 'User Profiles',
        GUEST_USER: 'Guest user',
    },
    SUPER: {
        WEB_LANGUAGE: 'Web Language',
        USER_ID: 'User ID',
        PREVIOUS_EVENT: 'Previous Event',
        PREVIOUS_SCREEN: 'Previous Screen',
        HOUR_OF_DAY: 'Hour of Day',
        DAY_OF_WEEK: 'Day of Week',
        PROFILE_NAME: 'Profile Name',
        SUBSCRIPTION_DATE: 'Subscription Date',
        SUBSCRIPTION_PRICE: 'Subscription Price',
        APP_VERSION: 'App Version',
        ACTIVE_PROFILE: 'Active Profile',
        GUEST_USER: 'Guest user',
    },
    INCREMENT: {
        TOTAL_ITEMS_WATCHED: 'Total Items Watched',
        TOTAL_WATCH_HOURS: 'Total Watch Hours',
        NO_OF_APP_OPEN: '# of App Open',
        NO_OF_USER_LOGIN: '# of User Login',
        NO_OF_SCREEN_OPENED: '# of Screen Opened',
        NO_OF_SEARCHES: '# of Searches',
    },
    MENU: {
        WATCHLIST: 'Watchlist',
        PROFILE_SETTINGS: 'Profile Settings',
        MY_ACCOUNT: 'My Account',
    },
    CAROUSEL: {
        SCREEN_NAME: 'Screen Name',
        CAROUSEL_NAME: 'Carousel Name',
        CAROUSEL_TYPE: 'Carousel Type',
        ITEM_POSITION: 'Item Position',
        CONTENT_ID: 'Content ID',
        CONTENT_NAME: 'Content Name',
        CONTENT_TYPE: 'Content Type',
        WATCH_PROGRESS: 'Watch Progress',
        ACTION_NAME: 'Action Name',
        SERIES_ID: 'Series ID',
        VALIDATED: 'Validated',
    },
    FORCE_SIGN_OUT: {
        FAILURE_REASON: 'Failure Reason',
        FAILURE_CODE: 'Failure Code',
    },
};

export const EVENT = {
    LOGIN: {
        SHOW_PASSWORD: 'Show Password',
        HIDE_PASSWORD: 'Hide Password',
        ATTEMP: 'Attempt', // {'Email': String, 'Phone': String}
        SUCCESS: 'Success', // {'Email': String, 'Phone': String}
        FAILED: 'Failed', // {'Login Failure Type': String["Client","Server"], 'Login Failure Reason': ['Empty email or password' ,'Invalid email' {ErorrMessageFromServer} ]
        FORGET_PASSWORD: 'Forgot Password', //If user clicked on the forget password link
        REGISTER: 'Register Attempt', //If user clicked on the registration link
        SIGN_OUT: 'Web Sign out',
        DEVICE_VIEW: 'Login - Devices - View',
        DEVICE_DELETE_SUCCESS: 'Login - Devices - Delete Success',
        DEVICE_DELETE_FAILED: 'Login - Devices - Delete Failed',
    },
    SEARCH_RESULTS: {
        VIEW: 'View',
        ITEM_CLICK: 'Carousel - Item click', // { 'Item Type': String[ 'Rewind', 'Movie', 'Series', 'Episode','Person'], Linear Properties OR  VOD Properties }
        ITEM_PLAY: 'Item play',
        SORTING_CLICK: 'Sorting click', // {'Sorting Title': String Sorting Title in EN }
        SORTING_SELECTED: 'Sorting selected',
        FILTER_CLICK: 'Filter click',
        FILTER_SELECTED: 'Filter selected', // { 'Filter Title': String Filter Title in EN }
        RECOMMENDATION_ITEM_CLICK: 'Carousel - Item Click', // { 'Recommendation Type':String Ex. ['Recommendations','Popular Searches','More Like This'] , VOD Properties   }
        RECOMMENDATION_ITEM_PLAY: 'Recommendations - Item Play',
    },
    PROMOTIONS: {
        PLAY: 'Promotions - Play', // * VOD Properties or Linear Properties
        INFO: 'Promotions - Info', // * VOD Properties or Linear Properties
    },
    CONTINUE_WATCHING: {
        ITEM_PLAY: 'Continue Watching - Play',
        ITEM_CLICK: 'Carousel - Item Click', // {'Program Type': String{ Linear, VOD }, Linear Properties or VOD Properties}
        QUICK_ACTION_MENU_OPENED: 'Quick Action Menu - Opened',
        QUICK_ACTION_MENU_DISMISSED: 'Quick Action Menu - Dismissed',
        QUICK_ACTION_CLICKED: 'Quick Action - Clicked',
    },
    WATCHLIST_CAROUSEL: {
        SEE_ALL: 'WATCHLIST - See All',
        ITEM_CLICK: 'Carousel - Item Click', // {'Watchlist Type': String{ Linear, VOD }, Linear Properties or VOD Properties}
        ITEM_PLAY: 'WATCHLIST - Item Play',
    },
    TV_GUIDE_CAROUSEL: {
        SEE_ALL: 'TV Guide - See All',
        PROGRAM_CLICK: 'TV Guide - Program Click',
    },
    REWIND: {
        SEE_ALL: 'REWIND - See All',
        LIST_SCROLL: 'REWIND - List Scroll',
        ITEM_CLICK: 'REWIND - Item click',
        ITEM_PLAY: 'WATCHLIST - Item Play', // { Linear Properties}
        SEARCH_SCROLL: 'REWIND - Search Scroll',
    },
    PROVIDER: {
        PROVIDER_ITEM_CLICK: 'Provider - Item Click', //	{'Provider Name':String ["JawwyTV", "Starzplay", "Blu TV", etc...] }
    },
    CAROUSEL: {
        SEE_ALL: 'Carousel - See All', // {'Carousel Name': String}
        ITEM_CLICK: 'Carousel - Item Click', // * {'Carousel Name': String, VOD Properties}
        ITEM_PLAY: 'Carousel - Item Play', // * {'Carousel Name': String, VOD Properties}
    },
    NAV_MENU: {
        ITEMCLICK: 'Nav Menu - Item click', // { 'Item Title':String }
    },
    LIVE_TV: {
        WATCHED: 'Watched', // Time Event: Strats with "Live TV - View" event , increment "Total Watch Hours" people property with total duration in Hours(If not Trailer)
        CHANNEL_CLICK: 'Channel Click', // { 'Channel Name': String Name in EN ,'Channel Number': Number,'Channel Is Fav': Boolean }
        START_PLAYING: 'Start Playing', // { 'Item Type': String [Live, Rewind], Linear Properties } Log "Item Played" Event with Type From Global Section (If NOT Trailer) This will be called first time, switch channel, and click a rewind program from list
        PAUSE_CLICK: 'Pause Click',
        PLAY_CLICK: 'Play Click',
        SEEK: 'Seek',
        BUFFERING: 'Buffering', // Tiem Event
        START_OVER_CLICK: 'Start Over Click',
        GO_LIVE_CLICK: 'Go Live Click',
        SCREEN_CLICK: 'Screen Click', // {'Action': String ['Hide Controls', 'Show Controls']}
        ERROR_POPUP: 'Error Popup', // {'Error Code': String} to include stream concurrency errors
        FILTER_CLICK: 'Filter Click',
        FILTER_SELECTED: 'Filter Selected', // {'Filter Name': String in EN,'Channel Count': Count}
        MORE_ACTIONS_CLICK: 'More Actions Click',
        ADD_CHANNEL_TO_FAV: 'Add Channel to Fav', // { 'Channel Name': String Name in EN ,'Channel Number': Number}
        REMOVE_CHANNEL_FROM_FAV: 'Remove Channel from Fav', // { 'Channel Name': String Name in EN ,'Channel Number': Number}
        MORE_PROGRAMS_EXPAND: 'More Programs - Expand',
        MORE_PROGRAMS_CLOSE: 'More Programs - Close', // Time Event: Starts with "Live TV - More Programs - Expand" event
        MORE_PROGRAMS_SCROLL: 'More Programs - Scroll',
        MORE_PROGRAMS_ITEM_CLICK: 'More Programs - Item Click', // { Linear Properties }
        CONCURRENCY_FAILED: 'Concurrency - Failed', // Concurrency - Failed
        SEARCH_CLICK: 'Search - Click',
        SEARCH_RESULTS_CLICK: 'Search Results - Item Click',
    },
    CATCHUP_PLAYER: {
        PAUSE_CLICK: 'VOD Player - Pause Click',
        PLAY_CLICK: 'VOD Player - Play Click',
        SEEK: 'VOD Player - Seek',
        BUFFERING: 'VOD Player - Buffering',
        ERROR_POPUP: 'VOD Player - Error Popup',
        START: 'VOD Player - Start',
        COMPLETED: 'VOD Player - Completed',
        SEEKED: 'VOD Player - Seek',
    },
    REWIND_LISTING: {
        // -Log this event after the data loaded
        // -{Section} will be replaced by the current displayed Category Ex. Entertainment, Movies, ....
        // It is written like this to make it dynamic according what is coming from configuration
        VIEW: '{Section} - View', // { 'Items Count': Number How many rewinds shown
        TIME_SPENT: '{Section} - Time Spent', // {Time Spent Event}
        ITEM_CLICK: '{Section} - Item click', // { 'List Index': Number , Linear Properties }
        SORTING_CLICK: '{Section} - Sorting click',
        SORTING_SELECTED: '{Section} - Sorting selected', //  { 'Sorting Title': String Sorting Title in EN }
    },
    VOD_LISTING: {
        VIEW: 'View', // { 'VOD Provider', 'VOD Category' }}
        ITEM_CLICK: 'Carousel - Item Click', // VOD Properties
        ITEM_PLAY: 'Play Click', // VOD Properties
        FILTER: 'Filter', // { 'Filter Name' , 'VOD Provider', 'VOD Category' }
        SORT: 'Sort', // { 'Sorting Type' , 'VOD Provider' , 'VOD Category' }
    },
    VOD_DETAILS: {
        VIEW: 'View', // VOD Properties
        WATCH_TRAILER: 'Watch Trailer', // VOD Properties
        WATCH_CLICK: 'Watch Click', // VOD Properties
        SEASON_CLICK: 'Season Click', // { 'Season Number': Number, 'Series Name': String: Name in EN
        EPISODE_PLAY_CLICK: 'Episode Play Click', // VOD Properties
        PURCHASE_CLICK: 'Purchase Click',
    },
    SEASONS: {
        SEASON_CLICK: 'Season Click', // { 'Season Number': Number, 'Series Name': String: Name in EN }
        EPISODE_PLAY_CLICK: 'Episode Play Click', // VOD Properties
    },
    MORE_LIKE_THIS: {
        MORE_LIKE_ITEM_CLICK: 'More Like - Item Click', // VOD Properties
    },
    VOD_PLAYER: {
        // Log "Item Played" Event with Type From Global Section (If NOT Trailer)
        START: 'Start', // { VOD Properties ,'VOD Duration': String HH:MM:SS, 'Video Type': String [Movie, Trailer] }
        // increment "Total Watch Hours" people property with total duration in Hours(If not Trailer)
        COMPLETED: 'Completed', // { VOD Properties Time Event: Strats with "VOD Player - Start" event, 'PlayTime': Minutes }
        PAUSE_CLICK: 'Pause Click',
        PLAY_CLICK: 'Play Click',
        SEEK: 'Seek',
        BUFFERING: 'Buffering', // Time Event
        SCREEN_CLICK: 'Screen Click', // {'Action': String ['Hide Controls', 'Show Controls']
        ERROR_POPUP: 'Error Popup', // {'Error Code': String Error code displayed on the screen} to include stream concurrency errors
        MORE_ACTIONS_CLICK: 'More Actions',
        AUDIO_SUBTITLES_CLICK: 'Audio & Subtitles - Click',
        AUDIO_SUBTITLES_APPLY: 'Audio & Subtitles - Apply', // { 'Selected Audio': String['AR', 'EN'] , 'Selected Subtitle':  String['AR', 'EN'] }
        AUDIO_SUBTITLES_CANCEL: 'Audio & Subtitles - Cancel',
        NEXT_EPISODE_VIEW: 'Next Episode - View',
        NEXT_EPISODE_START_PLAY: 'Next Episode - Start Play', // { 'Source': String['Auto', 'Play Button'] }
        NEXT_EPISODE_REPLAY_CURRENT: 'Next Episode - Replay Current',
        SEASON_CLICK: 'Season Click', // { 'Season Number': Number, 'Series Name': String: Name in EN }
        EPISODE_PLAY_CLICK: 'Episode Play Click', // VOD Properties
        CONCURRENCY_FAILED: 'Concurrency - Failed', // Concurrency - Failed
    },
    IMAGES_CAROUSEL: {
        IMAGE_CLICK: 'Carousel - Click',
    },
    WATCHLIST: {
        VIEW: 'View', // *
        ITEM_CLICK: 'Carousel - Item click', // { 'Item Type':	String ['Linear', 'VOD'] , Linear Properties or VOD Properties }
        ITEM_PLAY: 'Item Play', // { 'Item Type':	String ['Linear', 'VOD'] , Linear Properties or VOD Properties }
        // SORTING_CLICK: 'Watchlist - Sorting click',
        // SORTING_SELECTED: 'Watchlist - Sorting selected', // { 'Sorting Title': String Sorting Title in EN }
        // FILTER_CLICK: 'Watchlist - Filter click',
        // FILTER_SELECTED: 'Watchlist - Filter selected', // { 'Filter Title': String Filter Title in EN
        // EDIT_CLICK: 'Watchlist - Edit Click',
        // EDIT_MODE_REMOVE_ITEM: 'Watchlist - Edit Mode - Remove Item', // { 'Title Name': String Asset name in EN, 'Watchlist Type': String[ 'Rewind', 'Movie', 'Series', 'Episode'] }
        // EDIT_FINISH: 'Watchlist - Edit Finish'
        API_ERROR_GET_WATCHLIST: 'Api Error Get from Watchlist',
        API_ERROR_ADD_WATCHLIST: 'Api Error Add to Watchlist',
        API_ERROR_REMOVE_WATCHLIST: 'Api Error Remove from Watchlist',
    },
    BOOKMARK: {
        API_ERROR_GET_BOOKMARK: 'Api Error Get from Bookmark',
        API_ERROR_ADD_BOOKMARK: 'Api Error Add to Bookmark',
        API_ERROR_DELETE_BOOKMARK: 'Api Error Delete from Bookmark',
    },
    COUNTRY_RIGHTS_ALERT: {
        COUNTRY_RIGHTS_ALERT_VIEW: 'Country Rights Alert - View', // {'Country': String}
        COUNTRY_RIGHTS_ALERT_CLOSE: 'Country Rights Alert - Close',
    },
    // Global Events that will be sent from any screen.
    GLOBAL: {
        ADD_TO_WATCHLIST: 'Add Watchlist', // * { 'Watchlist Type':String [Rewind, Movie, Series, Episode] , Linear Properties or VOD Properties ,'Screen Name': String }
        REMOVE_FROM_WATCHLIST: 'Remove Watchlist', // * { 'Watchlist Type':String [Rewind, Movie, Series, Episode] , Linear Properties or VOD Properties ,'Screen Name': String }
        // increment "# of Searches" people property
        // Change "Last Search Keyword" people property
        // Change "Last Search" Date people property
        SEARCH: 'Search', // { 'Keyword': String, 'Source': String [Typing, History],'Screen Name': String
        // increment "Total Items Watched" people property
        // Change "Last Watch" people property
        // With any played item (Except Trailers) to get indications about that is most used on the app
        ITEM_PLAYED: 'Item Played', // {'Item Type': String [ 'Rewind', 'Movie', 'Episode','Live'], 'Item Name': String Name in EN
        NETWORK_ERROR_POPUP: 'Network Error Popup', // {'Current Screen': String } to track how many user saw Network error popup,
        PAGE_VIEW: 'View',
    },
    PROFILE: {
        PROFILES_VIEW: 'Profiles - View',
        PROFILES_ADD: 'Profiles - Add',
        PROFILES_ADD_SUCCESS: 'Profile Add - Success',
        PROFILES_ADD_FAILED: 'Profile Add - Failed',
        PROFILES_SELECT: 'Profiles - Select',
        PROFILES_EDIT: 'Profiles - Edit',
        PROFILES_EDIT_VIEW: 'Profile Edit - View',
        PROFILES_EDIT_SUCCESS: 'Profile Edit - Success',
        PROFILES_EDIT_FAILED: 'Profile Edit - Failed',
        PROFILES_EDIT_DELETE: 'Profile Edit - Delete',
        PROFILES_SETUP_CREATE_PROFILE: 'Profile Setup - Create Profiles',
        PROFILES_EDIT_AVATAR: 'Change Profile Avatar',
        PROFILES_EDIT_AVATAR_COMPLETED: 'Change Profile Avatar Completed',
    },
    OVERLAY: {
        ADDON_SUBSCRIPTION: {
            SUBSCRIBE: 'VOD Details - Subscribe - Click',
            POPUP_VIEW: 'VOD Details - Subscription Popup - View',
            POPUP_SUBSCRIBE: 'VOD Details - Subscription Popup - SUBSCRIBE',
            POPUP_DISMISS: 'VOD Details - Subscription Popup - Dismiss',
        },
    },
    RECOMMENDATION: {
        ERROR_API_RECOMMENDATION: 'ERROR_API_RECOMMENDATION',
    },
    FORCE_SIGN_OUT: 'Force Sign Out',
    REMINDER: {
        SET_SUCCESS: 'Reminder - Add New',
        UNSET_SUCCESS: 'Reminder - Remove',
        SET_FAIL: 'Reminder - Add New - Failure',
        UNSET_FAIL: 'Reminder - Remove - Failure',
    },
    CONTENT_RATING: {
        CONTENT_RATING_ADD: 'Content Rating - Add',
        CONTENT_RATING_REMOVE: 'Content Rating - Remove',
    },
    WATCHLIST_ACTION: {
        ADD: 'Watchlist - Add',
        REMOVE: 'Watchlist - Remove',
    },
    PROFILE_SETTINGS: {
        HISTORY_CLICK: 'Profile Settings - Viewing Activity - Click',
    },
    COLD_START: {
        COLD_START_VIEW: 'Content Preferences - View',
        COLD_START_SELECT: 'Content Preferences - Select',
        COLD_START_SUBMIT: 'Content Preferences - Submit',
    },
    CONSENT: {
        CONSENT_TC_VIEW: 'Consent - T&C - View',
        CONSENT_TC_SIGNOUT: 'Consent - T&C - Sign out',
        CONSENT_TC_PROMPT: 'Consent - T&C - Prompt',
        CONSENT_TC_NEXT: 'Consent - T&C - Next',
        CONSENT_MARKETING_VIEW: 'Consent - Marketing - View',
        CONSENT_MARKETING_PROMPT: 'Consent - Marketing - Prompt',
        CONSENT_MARKETING_NEXT: 'Consent - Marketing - Next',
        CONSENT_TOASTE: 'Consent - Toast MSG',
        KIDS_PROFILE_CONSENT_VIEW: 'Kids Profile - Consent - View',
        KIDS_PROFILE_EXIT: 'Kids Profile - Exit',
    },
    STC_PLAY_GAMES_CAROUSEL: {
        ITEM_CLICK: 'Carousel - Item Click',
        GAME_DETAIL: 'Game Details - View',
        GAME_DETAIL_PLAY: 'Game Details - Play',
    },
    MOODS: {
        MOOD_TYPE_SELECT: 'Mood - Type - Select',
        MOOD_CATEGORY_SELECT: 'Mood - Category - Select',
        MOOD_ITEM_CLICK: 'Mood - Item - Click',
    },
    CATCHUP: {
        CAROUSEL_ITEM_CLICK: 'Carousel - Item Click',
        PROMOTION_CLICK: 'Home - Promotions - Click',
    },
    NEW_AND_HOT: {
        CATEGORY_CLICK: 'Category Click',
        CATEGORY_PAGE_ITEM_CLICK: 'Category Page - Item Click',
        CATEGORY_PAGE_REMINDER_CLICK: 'Category Page - Reminder Click',
        CATEGORY_PAGE_ADD_WACTHLIST_CLICK: 'Category Page - Add Item to Watchlist',
        CATEGORY_PAGE_ITEM_PLAY: 'Category Page - Item Play',
        CATEGORY_PAGE_PLAY_TRAILER: 'Category Page - Play trailer',
    },
    AVOD: {
        NO_ADS_CTA_CLICK: 'No Ads CTA - Click',
        UPGRADE_STARTED: 'Upgrade Started',
        NO_ADS_UPGRADE_TO_PREMIUM_EXIT_CLICK: 'No Ads - Upgrade to Premium Exit Click',
        PRE_ROLL_AD_START: 'Ad Start',
        PRE_ROLL_AD_COMPLETED: 'Ad Completed',
        PRE_ROLL_VIDEO_STARTED_AFTER_AD: 'Video Started After Ad',
        PRE_ROLL_USER_EXITED_DURING_AD: 'User Exited During Ad',
        PRE_ROLL_USER_PAUSE_THE_AD: 'User Pause The Ad',
        PRE_ROLL_USER_RESUME_THE_AD: 'User Resume The Ad',
        PRE_ROLL_AD_REQUESTED: 'Ad Requested',
        PRE_ROLL_AD_ELIGIBLE_CONTENT: 'Ad Eligible Content',
        PRE_ROLL_AD_RECEIVED: 'Ad Received',
    },
    MIDROLL: {
        AD_START: 'Ad Start',
        AD_COMPLETED: 'Ad Completed',
        VIDEO_STARTED_AFTER_AD: 'Video Started After Ad',
        USER_EXITED_DURING_AD: 'User Exited During Ad',
        USER_PAUSE_THE_AD: 'User Pause The Ad',
        USER_RESUME_THE_AD: 'User Resume The Ad',
        AD_REQUESTED: 'Ad Requested',
        AD_RECEIVED: 'Ad Received',
    },
    CAST_CREW: {
        VOD_CAST_CREW_VIEW: 'VOD Details - Cast - Item Click',
        FILMOGRAPHY_VIEW: 'Filmography - View',
    },
    // This config has been moved, should be removed after testing...
    GAMIFICATION: {
        GAMIFICATION_CARD_CLICKED: 'Gamification Card - Clicked',
        REWARDS_DASHBORAD_VIEWED: 'Rewards Dashboard - Viewed',
        MOVIES_AND_SHOWS: 'Movies and Shows - Clicked',
        LIVE_TV: 'Live TV - Clicked',
        TVOD_RENT: 'TVOD Rent - Clicked',
        SUBSCRIPTION_UPGRADE_CHOSEN: 'Subscription Upgrade - Chosen',
        REWARDS_VIEWED: 'Rewards Screen - Viewed',
        REDEEM_REWARD_CLICKED: 'Redeem Reward - Clicked',
        REDEEM_REWARD_INITIATED: 'Redeem Points - Initiated',
    },
    PPV: {
        PPV_EVENT_VIEWED: 'PPV Event Viewed',
        PPV_REMINDER_SET: 'PPV Reminder Set',
        PPV_REMINDER_UN_SET: 'PPV Reminder Unset',
        PPV_PURCHASED_STARTED: 'PPV Purchase Started',
        PPV_PURCHASED_COMPLETED: 'PPV Purchase Completed',
        PPV_PURCHASED_FAILED: 'PPV Purchase Failed',
    },
    CHANNELS_FAVORITE: {
        API_ERROR_GER_CHANNEL_FAVORITE: 'Api Error Get Channel to Favorite',
        API_ERROR_ADD_CHANNEL_FAVORITE: 'Api Error Add Channel to Favorite',
        API_ERROR_REMOVE_CHANNEL_FAVORITE: 'Api Error Remove Channel from Favorite',
    },
    PAYMENT: {
        IN_APP_MESSAGE_VIEWED: 'Payment - In-App Message Viewed',
        IN_APP_MESSAGE_ACTION: 'Payment - In-App Message Action',
    },
};
